<template>
  <div>
    <quotationTable
      :tabShow="'pending'"
      :unfixedTableThead="unfixedTableThead"
      :tableData="tableData"
      :totalNum="totalNum"
      @handleClick="handleClick"
      @child-event="getLists"
    ></quotationTable>
  </div>
</template>

<script>
import quotationTable from "../../components/quotationTable.vue";
import { querySeekPageForSupplierLists } from "@/app/electronicQuotation/api/all";

export default {
  components: {
    quotationTable
  },
  data() {
    return {
      tableData: [],
      totalNum: 0,
      unfixedTableThead: [
        {
          label: "询价单编号",
          prop: "seekCode",
          width: "120",
          checked: true,
          align: "left",
          fixed: "left"
        },
        {
          label: "询价标题",
          prop: "seekTitle",
          width: "253",
          checked: true,
          align: "left",
          fixed: "left"
        },
        {
          label: "采购单位",
          prop: "purchaseOrgName",
          width: "210",
          checked: true,
          align: "left"
        },
        {
          label: "参与供应商名称",
          prop: "businessName",
          width: "210",
          checked: true,
          align: "left"
        },
        {
          label: "询价开始时间",
          prop: "seekStartTime",
          width: "150",
          checked: true,
          align: "left"
        },
        {
          label: "询价截止时间",
          prop: "seekOffTime",
          width: "150",
          checked: true,
          align: "left"
        },
        {
          label: "要求到货日期",
          prop: "requiredDeliveryDate",
          width: "110",
          checked: true,
          align: "left",
          type: "time"
        },
        // 新增的东西
        {
          label: "业务类型",
          prop: "sourceSystem",
          width: "110",
          checked: true,
          align: "left",
          type: "sourceSystem"
        }
      ]
    };
  },
  methods: {
    handleClick(row, value) {
      if (value === 1) {
        this.$router.push(
          `/electronicQuotation/electronicQuotationDetail/detail/${row.seekId}/${row.seekSupplierId}`
        );
      } else if (value === 2) {
        this.$router.push(
          `/electronicQuotation/electronicQuotationDetail/detail/${row.seekId}/${row.seekSupplierId}`
        );
      }
    },
    getLists(data) {
      let openId = JSON.parse(localStorage.getItem("userInfo")).openId || 0;
      querySeekPageForSupplierLists({
        ...data,
        quoteType: 1,
        openId: openId,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
        }
      });
    }
  }
};
</script>
